import { IAdContainerPort } from '../domain/ports/ad-container.port';
import { ConfigStore } from '../js/stores/config.store';
import { MraidAdapter } from './adapters/mraid.adapter';

export class AdContainerAdapterFactory {
  static create(
    msAdsOptions: Record<string, any>,
    configStore: ConfigStore
  ): IAdContainerPort {
    return new MraidAdapter(msAdsOptions, configStore);
  }
}
